<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row

    >
      <v-col cols="12">
        <v-card>
          <v-list
            subheader>
            <v-subheader>{{ $store.state.schoolName }}</v-subheader>
            <v-divider/>
            <v-list-item
              v-for="(contactDetail, key) in filteredSchoolDetails"
              :key="key">
              <v-list-item-content>
                <v-list-item-title class="body-1">

                  <b>{{ contactDetail.name }}: </b>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <a
                    v-if="contactDetail.href_prefix !== 'url'"
                    :href="contactDetail.href_prefix + ':' + contactDetail.value">{{ contactDetail.value }}</a>
                  <a
                    v-else
                    :href="getValidUrl(contactDetail.value)"
                    target="_blank">{{ contactDetail.value }}</a>

                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col
        class="mt-3"
        cols="12"
        v-if="teachersDetails.length">
        <v-card>
          <v-list
            subheader>
            <v-subheader>{{ teacherHeading }}</v-subheader>
            <v-divider/>
            <v-list-item
              v-ripple
              v-for="(contactDetail, key) in teachersDetails"
              :key="key">
              <v-list-item-content>
                <v-list-item-title class="body-1">
                  <v-row>
                    <v-col cols="6">
                      <b>{{ contactDetail.name }}: </b>
                    </v-col>
                    <v-col cols="6">
                      <a :href="'mailto:' + contactDetail.email">{{ contactDetail.email }}</a>
                    </v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  data: () => ({
    schoolDetails: [],
    teachersDetails: []
  }),
  methods: {
    getValidUrl: function (url) {
      if (!url.includes('http://') && !url.includes('https://')) {
        return '//' + url
      } else {
        return url
      }
    }
  },

  computed: {
    teacherHeading: function () {
      if (this.teachersDetails.length > 1) {
        return 'Class Teachers'
      }

      return 'Class Teacher'
    },
    filteredSchoolDetails: function () {
      return this.schoolDetails.filter(contactDetail => contactDetail.value !== '')
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('caregiversV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.userId + '/pupilsV2/' + vm.$store.state.pupilId + '/contactDetailsV2')
        .then(resp => {
          vm.schoolDetails = resp.data.schoolDetails
          vm.teachersDetails = resp.data.teachersDetails
          vm.$store.commit('loading', false)
        })
    })
  }
}
</script>
